<!--
 * @Author: QWX
 * @Description:发票申请详情
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-29 15:30:45
-->
<template>
  <zl-saas-container>
    <!-- 操作记录 -->
    <operRecord :id="$route.query.id" />
    <!-- 发票申请基本信息 -->
    <baseInfo :baseInfo="basicForm" class="m-b"/>
    <!-- 主订单列表 -->
    <orderList :id="$route.query.id" v-if="basicForm.supplierCode" :supplierCorp="basicForm.supplierCode" class="m-b" />
    <!-- 开票信息、开票记录 -->
    <invoiceInfo :basicForm="basicForm" :isView="isView" class="m-b"/>
  </zl-saas-container>
</template>
<script>
import operRecord from '@/components/business/operRecord.vue'
import baseInfo from '@/components/invoiceManage/detail/baseInfo'
import orderList from '@/components/invoiceManage/detail/orderList'
import invoiceInfo from '@/components/invoiceManage/detail/invoiceInfo'
import { mapActions } from 'vuex'
export default {
  name: 'PurchaserInvoiceManageDetail',
  components: {
    baseInfo,
    orderList,
    operRecord,
    invoiceInfo
  },
  data() {
    return {
      basicForm: {},
      isView: true
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions([
      'getInvoice'
    ]),
    /**
     * @description: 初始数据
     */
    async initData() {
      await this.getInvoice({ invoiceId: this.$route.query.id }).then(res => {
        this.basicForm = res
      })
    }
  }
}
</script>
